import React, { Component } from 'react';

class Message extends Component {
	render() {
		return (
			<p>There are currently no products matching your requirements</p>
		);
	}
}

export default Message;
